import { Sparkle } from "lucide-react";

const items = ["Diciottesimi", "Cerimonie", "Eventi Aziendali", "Compleanni", "Feste Private"];

function Strip() {
  return (
    <div className="flex shrink-0 items-center gap-16 pr-16">
      {items.map((item) => (
        <span key={item} className="flex items-center gap-16">
          <span className="whitespace-nowrap font-serif text-4xl uppercase tracking-wide text-dusty/80 md:text-5xl">
            {item}
          </span>
          <Sparkle className="h-5 w-5 shrink-0 text-sand/70" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-white/10 bg-[#060607] py-10"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max">
        <Strip />
        <Strip />
      </div>
    </section>
  );
}
